// Resolve a route meta title, always passing a context object.
// Signatory detail titles destructure { router }; omitting the argument throws.

export function resolveRouteTitle(meta, item, context = {}) {
    if (typeof meta?.title === "function") {
        return meta.title(item || {}, context ?? {});
    }
    return item?.Number || item?.Title || meta?.name;
}
